import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatStepperModule} from '@angular/material/stepper';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDividerModule} from '@angular/material/divider';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatListModule} from '@angular/material/list';
import {MatTableModule} from '@angular/material/table';

// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';
import { AuthGuard } from 'app/auth/auth.guard';

import { ReqStepperComponent } from './req-stepper.component';

const rutas: Routes = [
    // trust index
    {
        path     : 'companies/requirement-steps/:id',
        component: ReqStepperComponent,
        canActivate: [AuthGuard]
    }
];

@NgModule({
  declarations: [ReqStepperComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(rutas),
    FlexLayoutModule,
    TranslateModule,
    MatStepperModule,
    MatFormFieldModule,
    MatDividerModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    MatSidenavModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatListModule,
    MatTableModule
  ]
})
export class ReqStepperModule { }
